import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { DashboardInformation, DimensionType, MetricType } from '../domains/entities/Dashboard';
import { DashboardAdapter } from '../adapters/DashboardAdapter';
import { IYearMonth } from '@/coreDomainsModule/date';

/**
 * 集計取引の切り口別データ取得UseCase(集計)
 */
export class GetByDimensionAggBizUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 在庫削減ダッシュボードの詳細情報取得
   * @param metricType - 分析種別
   * @param dimensionType - 切り口種別
   * @param targetYear - 対象年
   * @param targetMonth - 対象月
   * @param targetPeriod - 集計期間
   * @param forecastAccuracyConsiderationMonths - 正答率算出に考慮する過去月数
   * @param sortType - ソートタイプ
   * @param sortTarget - ソート対象
   * @param limit - 表示制限
   * @param offset - オフセット
   * @param filterItemInfo - フィルター情報
   */
  public async execute(
    metricType: MetricType,
    dimensionType: DimensionType,
    targetYear: number,
    targetMonth: number,
    targetPeriod: [IYearMonth, IYearMonth],
    forecastAccuracyConsiderationMonths?: number,
    sortType?: string,
    sortTarget?: string,
    limit?: number,
    offset?: number,
    filterItemInfo?: FilterContentItem[]
  ): Promise<INetworkResult<DashboardInformation, IError>> {
    const filterItem = filterItemInfo ? FilterService.convertFilterObject(filterItemInfo) : undefined;
    const convertedDimensionType = dimensionType === 'business' ? 'item' : dimensionType;
    const networkResult = await this.repository.getInventoryAnalyticsByDimensionAggregateBusiness(
      metricType,
      convertedDimensionType,
      targetYear,
      targetMonth,
      targetPeriod[0].year,
      targetPeriod[0].month,
      targetPeriod[1].year,
      targetPeriod[1].month,
      forecastAccuracyConsiderationMonths,
      sortType,
      sortTarget,
      limit,
      offset,
      filterItem
    );

    switch (networkResult.status.type) {
      case 'success': {
        const result = networkResult.status.data;
        return {
          status: {
            type: 'success',
            data: {
              metricType: metricType,
              dimensionType: dimensionType,
              dimensionValueGroups: DashboardAdapter.adaptDimensionValueGroupsForAggBiz(result),
            },
          },
        };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
